import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpResponse } from "@angular/common/http";
import { sellerApi } from "../../config";
import {
  getFileNameFromResponseContentDisposition,
  saveFile,
} from "../services/file.download.helper";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class FileService {
  apiURL: any;
  headerFileName: any;
  constructor(private http: HttpClient) {}
  // downloadFile(companyId,viewFlag) {
  //   debugger;
  //   const headers =  new HttpHeaders();
  //    if(viewFlag === true){
  //   this.apiURL = sellerApi.salesChallengeExcelDownload.replace('{companyId}', companyId);
  //   this.headerFileName = 'Base_Challenge_Claims.xlsx';
  // }
  //   if(viewFlag === 'Nexus'){
  //     this.apiURL = sellerApi.nexusChallengeExcelDownload.replace('{companyId}', companyId);
  //     this.headerFileName = 'DC_Nexus_Challenge_Claims.xlsx';
  //   }
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   console.log(headers.get('Content-Type'));
  //   // const url = `${this.config.baseUrl}/properties/${propertyId}/files/${fileId}`;
  //   const options = {
  //     headers: headers,
  //     observe: 'response' as 'body',
  //     responseType: 'blob' as 'json'
  //   }
  //   // Process the file downloaded
  //   this.http.get(this.apiURL, options).subscribe((res: any) => {
  //     res.setHeader('Content-Type', 'application/json');
  //       const fileName = getFileNameFromResponseContentDisposition(res);
  //       // const fileName = this.headerFileName;
  //       // const fileName = 'Base_Challenge_Claims.xlsx';
  //       saveFile(res.body, fileName);
  //   });
  // }
  excelDownloadFile(URL, fileName, fileNameFromHeader?) {
    this.apiURL = URL;
    this.headerFileName = fileName;
    const options = {
      observe: "response" as "body",
      responseType: "blob" as "json",
    };
    // Process the file downloaded
    this.http.get(this.apiURL, options).subscribe((res: any) => {
      if (fileNameFromHeader) {
        const fileName = getFileNameFromResponseContentDisposition(res);
        this.headerFileName = fileName;
      }
      //const fileName = getFileNameFromResponseContentDisposition(res);
      // const fileName = this.headerFileName;
      // const fileName = 'Base_Challenge_Claims.xlsx';
      saveFile(res.body, this.headerFileName);
    });
  }
  downloadFile(url: string): Observable<void> {
    return this.http
      .get(url, {
        responseType: "blob",
        observe: "response",
      })
      .pipe(
        tap((res) => {
          const contentDisposition = res.headers.get("content-disposition");
          let fileName = "downloaded-file";

          if (contentDisposition) {
            const matches = /filename="([^"]*)"/.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1];
            }
          }

          const blob = new Blob([res.body!]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }),
        map(() => void 0)
      );
  }
}
// salesChallengeExcelDownload(companyId) {
//     const url = sellerApi.salesChallengeExcelDownload.replace('{companyId}', companyId);
//     const options = new RequestOptions({responseType: ResponseContentType.Blob });
//         // Process the file downloaded
//         this.http.get(url, options).subscribe(res => {
//           const fileName = getFileNameFromResponseContentDisposition(res);
//           saveFile(res.blob(), fileName);
//       });
//   }

// public exportAsExcelFile(json: any[], excelFileName: string): void {
//   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
//   const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   this.saveAsExcelFile(excelBuffer, excelFileName);
// }
// private saveAsExcelFile(buffer: any, fileName: string): void {
//    const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
//    FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
// }
